import React, { useState, useEffect, useMemo } from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
// import find from 'lodash/find'
import { useScrollPosition } from 'react-use-scroll-position'
import Icon from './icon'
import { FlexibleLink } from './common/FlexibleLink'
import DatoCmsLink from '@m/datocms-components/DatoCmsLink'

import filter from 'lodash/fp/filter'
import flow from 'lodash/fp/flow'
import map from 'lodash/fp/map'
import orderBy from 'lodash/fp/orderBy'
import ProjectImage from './project-image'
import { Script } from 'gatsby'

const query = graphql`
  query SiteHeaderQuery {
    # Logo
    siteSettings: datoCmsSiteSetting {
      logo {
        alt
        asset {
          localImage {
            extension
            publicURL
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }

    # Menus - top menu
    menus: allDatoCmsCollapsibleMenuBlock {
      edges {
        node {
          locale
          topItemTitle
          topItemUrl
          orderingNumber
          links {
            title
            url
            page {
              ...DatoCmsLinkFieldPage
            }
          }
        }
      }
    }

    # Digitalzone Button
    pageSettings: allDatoCmsPageSetting {
      edges {
        node {
          locale
          digitalzoneTitle
          digitalzoneSlug
        }
      }
    }
  }
`

const Logo = ({ locale, image }) => (
  <Link
    to={locale === 'en' ? '/' : '/' + locale}
    aria-label={locale === 'en' ? 'Homepage' : 'Anasayfa'}
    title={locale === 'en' ? 'Homepage' : 'Anasayfa'}
  >
    <ProjectImage
      image={image}
      width="91"
      height="33"
      style={{ width: '100%', height: 'auto' }}
    />
  </Link>
)

const ShortMenu = (props) => {
  const { topMenuItems = [] } = props

  return (
    <nav className="SiteShortMenu">
      {topMenuItems.map((items, i) => (
        <div key={i} className="dropdown">
          <FlexibleLink
            key={i}
            url={items.topItemUrl}
            title={items.topItemTitle}
            className="SiteShortMenu-item dropdown-btn"
          />
          <ul className="dropdown-content">
            {items.links.map((link) => (
              <li
                className="SiteMenu-group-li p-0"
                key={`${link.getTitle()}${link.getUrl()}`}
              >
                <FlexibleLink
                  title={link.getTitle()}
                  url={link.getUrl()}
                  className="fw-text-light link-hover-red"
                />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  )
}

const SiteHeader = (props) => {
  const { locale = 'en', links } = props
  const data = useStaticQuery(query)
  // const pageSettings = find(data.pageSettings.edges, ['node.locale', locale]).node
  const [isShowSiteMenu, setShowSiteMenu] = useState(false)
  const { y } = useScrollPosition()

  const menus = useMemo(
    () =>
      flow([
        map('node'),
        filter(['locale', locale]),
        orderBy('orderingNumber', 'asc'),
        map((block) => {
          const nLinks = block.links.map((item) => new DatoCmsLink(item))

          return {
            ...block,
            links: nLinks
          }
        })
      ])(data.menus.edges),
    [data.menus.edges, locale]
  )
  const isClient = typeof window !== 'undefined'
  let $body = null

  if (isClient) {
    $body = document.querySelector('body')
  }

  useEffect(() => {
    if (isClient) {
      isShowSiteMenu
        ? $body.classList.add('show-SiteMenu')
        : $body.classList.remove('show-SiteMenu')
    }
  }, [$body, isClient, isShowSiteMenu])

  useEffect(() => {
    if (isClient) {
      y > 20
        ? $body.classList.add('fixed-SiteHeader')
        : $body.classList.remove('fixed-SiteHeader')
    }
  }, [$body, isClient, y])
  const alternateLink = links && links.find((l) => l.hreflang !== locale)

  return (
    <header className="SiteHeader">
      <div className="container">
        <div className="SiteHeader-inner">
          <Logo locale={locale} image={data.siteSettings.logo} />

          {/* BODY */}
          <Script
            src="https://7846fc2a54134827b6445e1c9ab0d2de.js.ubembed.com"
            referrerpolicy="origin"
          />

          <div className="SiteHeader-body">
            <ShortMenu topMenuItems={menus} />

            {/*  <FlexibleLink
              title={<Icon name="digitalzone" />}
              url={pageSettings.digitalzoneSlug}
              className="btn btn--line digital-zone"
            /> */}

            {/* Language switch button */}
            {!!alternateLink && (
              <FlexibleLink
                title={locale === 'en' ? 'TR' : 'EN'}
                url={alternateLink?.href || (locale === 'en' ? '/tr' : '/')}
                className="btn btn--line digital-zone px-0"
              />
            )}
          </div>

          {/* SWITCH */}
          <button
            className="SiteHeader-switch btn btn--icon"
            type="button"
            aria-label="Menu"
            onClick={() => setShowSiteMenu(!isShowSiteMenu)}
          >
            <Icon className="icon-hamburger" name="hamburger" />
            <Icon className="icon-close" name="close" />
          </button>
        </div>
      </div>
    </header>
  )
}

export default SiteHeader
